import AdminNexusHttpClient from './admin-nexus-http-client'

export default class PropertyLocalityService {
  constructor() {
    this.httpClient = new AdminNexusHttpClient('/admin/property-localities')
  }

  async get(property) {
    return await this.httpClient.get(`${property}`, {})
  }

  async set(payload) {
    return await this.httpClient.post('', payload)
  }
}
